// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectDeviceForm_root__2trZu"};